<template>
  <div>
    <ApexChart
      :element="`chart-availability-${element}`"
      :chartOption="chartFleetAvailability"
    />
  </div>
</template>
<script>
export default {
  props: {
    series: {
      type: Array,
      default: () => {
        return []
      },
    },
    element: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartFleetAvailability: {
        chart: {
          height: 350,
          type: 'line',
          stacked: false,
          zoom: {
            enabled: false,
          },
        },
        stroke: {
          width: [0, 0, 0, 5],
        },
        plotOptions: {
          bar: {
            columnWidth: '90%',
            dataLabels: {
              position: 'center', // Set position to 'top'
              hideOverflowingLabels: true,
            },
          },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',
          },
          formatter: function (val, opts) {
            // Hanya tampilkan label pada series pertama (Actual Availability)
            if (opts.seriesIndex === 3) {
              return val
            }
          },
        },
        legend: {
          show: false,
        },
        series: this.series,
        xaxis: {
          categories: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return val + '%' // memformat label sumbu y menjadi persentase
            },
          },
          max: 100, // set nilai maksimum pada sumbu y
          tickAmount: 5,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + '%'
            },
          },
        },
        // fill: {
        //   type: 'gradient', // Menambahkan fill tipe gradient
        //   gradient: {
        //     shade: 'light',
        //     type: 'vertical', // Gradasi vertikal
        //     shadeIntensity: 0.5,
        //     gradientToColors: ['#1235C5'], // Warna akhir gradasi
        //     inverseColors: false,
        //     opacityFrom: 0.85,
        //     opacityTo: 0.95,
        //     stops: [0, 100], // Titik awal dan akhir gradasi
        //   },
        // },
      },
    }
  },
}
</script>
